angular.module('gym.components').directive('editBookingSection', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/edit_booking_section.html.slim'),
    scope: {
      contact: '=',
      form: '=',
      booking: '=',
      params: '=',
      close: '&',
      onWaitlistAdded: '&'
    },
    controller: ["$document", "$rootScope", "$scope", "$state", "$modal", "$window", "$http", "$filter", "loadingAnimation", "Events", "Contacts", "EventService", "flash", "MessageService", function($document, $rootScope, $scope, $state, $modal, $window, $http, $filter, loadingAnimation, Events, Contacts, EventService, flash, MessageService) {
      var bookCurrentContact, bookFriend, confirmAddToWaitlist, enableRecurringBooking, gym;
      $scope.gym = gym = $rootScope.gym;
      $scope.$emit('contact:scrollToMainSection');
      $scope.attendanceOptions = ['Attended', 'Absent'];
      $scope.pageParams = {
        search: ''
      };
      $scope.getEventDetail = function(id) {
        var url;
        url = `/gyms/${gym.id}/calendar/events/${id}`;
        return $http.get(url).then(function(response) {
          return $scope.event = response.data;
        });
      };
      $scope.selectEvent = function() {
        var eventModal;
        return eventModal = $modal.open({
          template: require('templates/components/contacts/forms/select_contact_booking_event.html.slim'),
          controller: 'EventSelectCtrl',
          size: 'lg'
        }).result.then(function(event) {
          $scope.booking.event = event;
          $scope.getEventDetail(event.id);
          return $scope.getContactForBooking();
        });
      };
      $scope.getContactForBooking = function() {
        return EventService.getContactForBooking($scope.contact.name, $scope.contact.id, $scope.booking.event.id).then(function(contactForBooking) {
          return $scope.contactForBooking = contactForBooking;
        });
      };
      $scope.isFormValid = function() {
        if ($scope.params.bookFriend) {
          return $scope.booking.event && $scope.booking.student_id;
        } else {
          return $scope.booking.event;
        }
      };
      $scope.toggleFreeClass = function(value) {
        $scope.booking.free_class = value;
        $scope.booking.add_makeup_class = false;
        $scope.booking.makeup_class_membership_id = void 0;
        return $scope.booking.makeup_class_reason = void 0;
      };
      $scope.onBookingChange = function(data) {
        angular.extend($scope.booking, data);
        if (data.type && data.type !== 'one' && $scope.booking.add_makeup_class) {
          return $scope.toggleFreeClass(false);
        }
      };
      $scope.hideError = function(field) {
        var ref;
        return (ref = $scope.booking[field]) != null ? ref.errors = void 0 : void 0;
      };
      $scope.selectBookingTypeVisible = function() {
        return $scope.contact.type === 'member' && $scope.booking.event && !$scope.booking.event.free_class;
      };
      $scope.eventFullButHasAbsentBookingsMessageVisible = function() {
        return $scope.booking.event && $scope.booking.event.bookings_count >= $scope.booking.event.participant_limit && $scope.booking.event.non_absent_bookings_count < $scope.booking.event.participant_limit;
      };
      $scope.makeupClassOptionVisible = function() {
        var ref, ref1, ref2;
        if ($scope.params.bookFriend) {
          return;
        }
        if (!((ref = $scope.contactForBooking) != null ? (ref1 = ref.memberships_for_makeup_classes) != null ? ref1.length : void 0 : void 0)) {
          return;
        }
        return (((ref2 = $scope.contactForBooking) != null ? ref2.show_makeup_class_option : void 0) || $scope.showMakeupClassOption) && $scope.booking.type === 'one';
      };
      $scope.enabledMakeupClass = function() {
        var ref;
        $scope.booking.add_makeup_class = true;
        $scope.booking.free_class = false;
        if (!$scope.booking.makeup_class_membership_id && $scope.contactForBooking) {
          return $scope.booking.makeup_class_membership_id = (ref = $scope.contactForBooking.memberships_for_makeup_classes[0]) != null ? ref.id : void 0;
        }
      };
      enableRecurringBooking = function() {
        var recurringBookingParams;
        recurringBookingParams = {
          contact_id: $scope.contact.id,
          book_from_policy: $scope.booking.book_from_policy
        };
        return EventService.enableRecurringBooking($scope.booking, recurringBookingParams, $scope.event.id).then(function() {
          loadingAnimation.hide();
          return $scope.close();
        }, function(data) {
          var ref, ref1;
          loadingAnimation.hide();
          if ((ref = data.errors) != null ? ref.message : void 0) {
            return $scope.recurringBookingError = (ref1 = data.errors) != null ? ref1.message : void 0;
          }
        });
      };
      bookCurrentContact = function() {
        var lateAbsent, params, url;
        if ($scope.booking.type === 'recurring') {
          enableRecurringBooking();
          return;
        }
        if ($scope.booking.add_makeup_class) {
          params = {
            position: $scope.booking.event.bookings_count,
            student: $scope.contactForBooking,
            add_makeup_class: $scope.booking.add_makeup_class,
            makeup_class_membership_id: $scope.booking.makeup_class_membership_id,
            makeup_class_reason: $scope.booking.makeup_class_reason
          };
          url = `/gyms/${gym.id}/calendar/events/${$scope.event.id}/bookings`;
          return $http.post(url, {
            booking: params
          }).then(function(response) {
            flash.success = `Booking for ${response.data.student.name} added successfully`;
            $scope.close();
            return loadingAnimation.hide();
          });
        } else {
          url = `gyms/${gym.id}/calendar/events/${$scope.event.id}/bulk_bookings/book_${$scope.booking.type}`;
          lateAbsent = $scope.booking.type === 'one' && $scope.booking.attendance === 'Absent' && $scope.event.restrict_cancellations && !$scope.event.cancellable && $scope.event.allow_late_cancellations;
          params = {
            student_id: $scope.contact.id,
            event_id: $scope.event.id,
            number_of_events: $scope.booking.count,
            free_class: $scope.booking.free_class,
            attendance: $scope.booking.type === 'one' && !lateAbsent ? $scope.booking.attendance : void 0
          };
          return $http.post(url, params).then(function(response) {
            var booking, bookings, lastBookingDate;
            loadingAnimation.hide();
            bookings = response.data.bookings.valid;
            if (bookings.length) {
              lastBookingDate = $filter('date')(_.last(bookings).start_at);
              flash.success = `${bookings.length} events booked successfully. Last booking: ${lastBookingDate}.`;
              if (lateAbsent) {
                booking = bookings[0];
                booking.id = response.data.booking_id;
                EventService.confirmLateAbsent({
                  event: $scope.event,
                  booking: booking,
                  reloadAttendance: $scope.close
                });
                return;
              }
            } else {
              if ($scope.booking.type === 'one') {
                $scope.booking.event.errors = ['This event is currently full, please try another timeslot.'];
                flash.error = "Update failed. Please fix the errors below";
                return;
              }
              flash.success = response.data.message;
            }
            return $scope.close();
          }, function(response) {
            var eventIsFull, hasSuspension, ref;
            loadingAnimation.hide();
            if ($scope.event.invite_to_waitlist) {
              confirmAddToWaitlist();
              return;
            }
            $scope.failedBookings = response.data;
            eventIsFull = ((ref = $scope.failedBookings.bookings.invalid[0]) != null ? ref.validation_error : void 0) === 'Event full';
            hasSuspension = _.any($scope.failedBookings.bookings.invalid, function(b) {
              return /suspension/i.test(b.validation_error);
            });
            if ($scope.booking.type === 'one' && $scope.contactForBooking.memberships_for_makeup_classes.length && !eventIsFull && !hasSuspension) {
              $scope.showMakeupClassOption = true;
              if (!$scope.booking.makeup_class_membership_id) {
                return $scope.booking.makeup_class_membership_id = $scope.contactForBooking.memberships_for_makeup_classes[0].id;
              }
            }
          });
        }
      };
      $scope.onAttendanceBlocked = function(message) {
        return MessageService.message({
          title: 'Attendance blocked (signed waiver required)',
          message: message
        });
      };
      bookFriend = function() {
        var params;
        params = {
          position: $scope.booking.event.bookings_count,
          student_id: $scope.selectedContact.id,
          membership_taken_from_contact_id: $scope.contact.id,
          attendance_bypass: $scope.booking.attendance,
          free_class: $scope.booking.free_class
        };
        return Events.one(`${$scope.event.id}`).all('bookings').post(params).then(function() {
          flash.success = "Booking added successfully";
          $scope.close();
          return loadingAnimation.hide();
        }, function(response) {
          var eventErrors;
          loadingAnimation.hide();
          if (response.data.waiver_requirements_not_met) {
            return $scope.onAttendanceBlocked(response.data.message);
          } else {
            flash.error = "Update failed. Please fix the errors below or check membership conditions";
            eventErrors = angular.extend({}, response.data.errors);
            eventErrors['bookings.student'] = void 0;
            $scope.booking.event.errors = response.data.errors['bookings.event'] || eventErrors.event || eventErrors.student || _.flatten(_.values(eventErrors));
            return $scope.errors = response.data.errors;
          }
        });
      };
      $scope.save = function() {
        loadingAnimation.show();
        if ($scope.params.bookFriend) {
          return bookFriend();
        } else {
          return bookCurrentContact();
        }
      };
      confirmAddToWaitlist = function() {
        var message, params;
        message = "This event is currently full. Add contact to waitlist?";
        if ($window.confirm(message)) {
          params = {
            withoutNamespace: true,
            contact_id: $scope.contact.id
          };
          return Events.one(`${$scope.event.id}`).all('waitlist_attendees').post(params).then(function(response) {
            $scope.onWaitlistAdded();
            flash.success = `${response.contact_name} added to waitlist.`;
            $scope.close();
            return loadingAnimation.hide();
          }, function(response) {
            var ref;
            message = ((ref = response.data) != null ? ref.error_message : void 0) || "Request could not be completed. Please try again";
            return flash.error = message;
          });
        }
      };
      $scope.getContacts = function(text) {
        return Contacts.getList({
          all_contacts_search: text
        }).then(function(contacts) {
          return _.filter(contacts, function(contact) {
            return contact.type !== 'non_attending_contact';
          });
        });
      };
      $scope.onContactSelect = function(contact) {
        $scope.selectedContact = contact;
        $scope.booking.student_id = contact.id;
        return $scope.booking.membership_taken_from_contact_id = $scope.contact.id;
      };
      $scope.restoreName = function() {
        if ($scope.booking.errors) {
          $scope.booking.errors.contact_id = void 0;
        }
        return $scope.pageParams.search = $scope.selectedContact ? $scope.selectedContact.name : '';
      };
      return $scope.cancel = function() {
        return $scope.close();
      };
    }]
  };
});
